/**
 * The tabs across the top of every report.
 *
 * The reports are separate pages — each is its own route, so a link points
 * straight at one and a refresh keeps it — but they are one thing to the person
 * reading them, so they wear one tab strip. The active tab is read from the
 * route rather than passed in, so a page cannot disagree with the address bar
 * about which report it is.
 */
import { Link, useLocation } from 'react-router-dom';

const TABS = [
  ['/reports', 'Overview'],
  ['/sales-breakdown', 'Sales breakdown'],
  ['/customer-report', 'Customers'],
  ['/adjustments', 'Discounts & refunds'],
  ['/profit-loss', 'Profit and loss'],
  ['/balance-sheet', 'Balance sheet'],
  ['/tax', 'Tax'],
  ['/ledger', 'Ledger'],
  ['/purchase-report', 'Purchases'],
  ['/expense-report', 'Expenses'],
];

export function ReportTabs() {
  const { pathname } = useLocation();

  return (
    <div role="tablist" className="no-print mb-4 flex flex-wrap gap-1 border-b border-rule">
      {TABS.map(([to, label]) => {
        const active = pathname === to;
        return (
          <Link
            key={to}
            to={to}
            role="tab"
            aria-selected={active}
            className={`shrink-0 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
              active
                ? 'border-brand-400 text-brand-300'
                : 'border-transparent text-ink-2 hover:text-ink'
            }`}
          >
            {label}
          </Link>
        );
      })}
    </div>
  );
}
